import NativeSelect from '@mui/material/NativeSelect/NativeSelect';
import styled from 'styled-components';

export const Dropdown = styled(NativeSelect)`
  box-shadow: none !important;
  border: 2px solid #b6b6b6;
  border-radius: 8px;
  text-indent: 10px;
`;

export const Subtitle = styled.h4`
  fontSize: '16px',
  fontWeight: 600,
  color: '#444',
  margin: '0 0 15px 0',
  paddingBottom: '8px',
  borderBottom: '1px solid #e8e8e8',`;

export const Grid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${({ cols }) => cols}, 1fr);
  gap: 12px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-top: 15px;
  margin-top: 20px;
  border-top: 1px solid #e8e8e8;
`;

export const SectionTitle = styled.h3`
  fontSize: '16px',
  fontWeight: 600,
  margin: '0 0 15px 0',
  paddingBottom: '8px',
  color: '#444',
  borderBottom: '1px solid #e8e8e8'`;

export const Header = styled.div`
  display: 'flex',
  alignItems: 'center',`;

export const FormBody = styled.div`
  // display: flex;
  flex: 1;
  margin-bottom: 20px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9e9e9e;
  padding-bottom: 6px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 12px;
`;

export const RequiredMark = styled.span`
  color: #d32f2f;
  margin-left: 2px;
`;

export const FieldErrorText = styled.div`
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.2;
`;

// export const ModalBody: React.FC = ({}) => {}
